import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import ImageUploader from 'quill2-image-uploader';
import ImageFormat from 'scaleflow/utils/quill-extenstions/image-format';
import MarkdownFormat from 'scaleflow/utils/quill-extenstions/markdown-format';
import Quill from 'quill';
import imageResizeOptions from 'scaleflow/utils/quill-extenstions/image-resize';
import registerIfNotRegistered from 'scaleflow/utils/quill-extenstions/registerIfNotRegistered';
import InitiativeValidations from 'scaleflow/validators/initiative';
import imageUploadHandler from 'scaleflow/utils/quill-extenstions/image-uploader';

Quill.register('formats/image', ImageFormat, true);
registerIfNotRegistered(Quill, 'modules/imageUploader', ImageUploader);
registerIfNotRegistered(Quill, 'modules/markdown', MarkdownFormat);
export default class BacklogInitiativesInitiativeDescriptionController extends Controller {
  @service currentUser;
  @service session;
  @service organisation;
  @service intl;

  initiativeValidations = InitiativeValidations;

  queryParams = ['editMode'];
  @tracked editMode = false;

  get bon() {
    return this.model;
  }

  @action
  setDelta(changeset, e) {
    changeset.set('summary', e);
  }

  @action
  handleBlur(changeset) {
    //if page is not navigating away
    if (changeset.get('isPristine') === true) {
      this.isDisabled = true;
    } else if (changeset.get('isValid') === true) {
      this.isDisabled = false;
    } else {
      this.isDisabled = true;
    }
  }

  @action
  toggleEditMode() {
    this.editMode = !this.editMode;
  }

  @action
  handleProjectDescriptionSave(changeset) {
    changeset.save();
    this.toggleEditMode();
  }

  @action
  handleProjectDescriptionCancel(changeset) {
    changeset.rollback();
    this.toggleEditMode();
  }

  get modules() {
    const modules = {};
    modules.imageUploader = {
      upload: (file) => {
        return imageUploadHandler(
          this.session.idToken,
          this.organisation.id,
          file,
        ).then((s3Link) => {
          return s3Link;
        });
      },
    };

    modules.resize = imageResizeOptions(this.intl);
    modules.markdown = true;

    let toolbarOptions = [
      ['bold', 'italic', 'strike'], // toggled buttons
      ['blockquote', 'code-block'],

      [{ header: 1 }, { header: 2 }], // custom button values
      [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
      ['link', 'image', 'clean'], // remove formatting button
    ];
    modules.toolbar = toolbarOptions;
    return modules;
  }
}
